import { RouterOutlet, Routes } from '@angular/router';
import { NotFoundComponent } from './pages/errors/not-found/not-found.component';
import { LoginComponent } from './pages/auth/login.component/login.component';
import { RegisterComponent } from './pages/auth/register.component/register.component';
import { authGuard } from './core/guards/auth/auth.guard';
import { roleGuard } from './core/guards/role/role.guard';
import { permissionGuard } from './core/guards/permission/permission-guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'register',
    component: RegisterComponent,
  },
  {
    path: 'admin',
    loadComponent: () =>
      import('./layouts/admin-layout/admin-layout.compoment').then((m) => m.AdminLayoutCompoment),
    canActivate: [authGuard(), roleGuard(['DEVELOPPER', 'SUPERADMIN', 'ADMIN'])],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./pages/admin/dashboard/dashboard.component').then((m) => m.DashboardComponent),
        // canActivate: [permissionGuard(['ADMIN:DASHBOARD'])],
      },
      {
        path: 'users',
        loadComponent: () =>
          import('./pages/admin/users/user-list/user-list.component').then(
            (m) => m.UserListComponent
          ),
        canActivate: [permissionGuard(['USER:LIST_PAGINATED'])],
      },
      {
        path: 'roles',
        loadComponent: () =>
          import('./pages/admin/roles/role-list/role-list.component').then(
            (m) => m.RoleListComponent
          ),
        canActivate: [permissionGuard(['ROLE:LIST_PAGINATED'])],
      },
    ],
  },
  {
    path: 'storage',
    loadComponent: () =>
      import('./layouts/storage-layout/storage-layout.compoment').then(
        (m) => m.StorageLayoutCompoment
      ),
    canActivate: [roleGuard(['DEVELOPPER', 'SUPERADMIN', 'ADMIN'])],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./pages/storage/dashboard/dashboard.component').then((m) => m.DashboardComponent),
        canActivate: [permissionGuard(['DELIVERY:DASHBOARD'])],
      },
      {
        path: 'products',
        loadComponent: () =>
          import('./pages/storage/products/product-list/product-list.component').then(
            (m) => m.ProductListComponent
          ),
        canActivate: [permissionGuard(['PRODUCT:LIST_PAGINATED'])],
      },
      {
        path: 'categories',
        loadComponent: () =>
          import('./pages/storage/categories/category-list/category-list.component').then(
            (m) => m.CategoryListComponent
          ),
        canActivate: [permissionGuard(['PRODUCT_CATEGORY:LIST_PAGINATED'])],
      },
    ],
  },
  {
    path: 'delivery',
    loadComponent: () =>
      import('./layouts/delivery-layout/delivery-layout.compoment').then(
        (m) => m.DeliveryLayoutCompoment
      ),
    canActivate: [roleGuard(['DEVELOPPER', 'SUPERADMIN', 'ADMIN'])],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./pages/delivery/dashboard/dashboard.component').then(
            (m) => m.DashboardComponent
          ),
        canActivate: [permissionGuard(['DELIVERY:DASHBOARD'])],
      },
    ],
  },
  {
    path: 'unauthorized',
    loadComponent: () =>
      import('./pages/errors/unauthorized/unauthorized.component').then(
        (m) => m.UnauthorizedComponent
      ),
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];
